import React, { useState, useEffect } from "react";
import LifeSaverLayout from "../../components/LifeSaverLayout";
import api from "../../services/api";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiMapPin,
  FiCreditCard,
  FiAtSign,
  FiBriefcase,
} from "react-icons/fi";

const MyProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await api.get("/life-savers/profile");
      setProfile(response.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <LifeSaverLayout>
        <div className="spinner"></div>
      </LifeSaverLayout>
    );
  }

  if (!profile) {
    return (
      <LifeSaverLayout>
        <div className="card">
          <p>Unable to load profile information.</p>
        </div>
      </LifeSaverLayout>
    );
  }

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <LifeSaverLayout>
      <div className="page-header">
        <h1 className="page-title">My Profile</h1>
      </div>

      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">{getInitials(profile.full_name)}</div>
          <div>
            <div className="profile-name">{profile.full_name}</div>
            <div className="profile-email">{profile.email}</div>
          </div>
        </div>

        <div className="profile-details">
          <div className="pe-4">
          <div className="profile-row">
            <div className="profile-label">
              <FiUser style={{ marginRight: "0.5rem" }} />
              Full Name
            </div>
            <div className="profile-value">{profile.full_name}</div>
          </div>

          <div className="profile-row">
            <div className="profile-label">
              <FiAtSign style={{ marginRight: "0.5rem" }} />
              Username
            </div>
            <div className="profile-value">{profile.login_username}</div>
          </div>

          <div className="profile-row">
            <div className="profile-label">
              <FiBriefcase style={{ marginRight: "0.5rem" }} />
              Role
            </div>
            <div className="profile-value">
              {profile.role || "Not assigned"}
            </div>
          </div>

          <div className="profile-row">
            <div className="profile-label">
              <FiMail style={{ marginRight: "0.5rem" }} />
              Email
            </div>
            <div className="profile-value">{profile.email}</div>
          </div>
        </div>
        <div>
          <div className="profile-row">
            <div className="profile-label">
              <FiPhone style={{ marginRight: "0.5rem" }} />
              Mobile
            </div>
            <div className="profile-value">{profile.mobile}</div>
          </div>

          <div className="profile-row">
            <div className="profile-label">
              <FiPhone style={{ marginRight: "0.5rem" }} />
              WhatsApp
            </div>
            <div className="profile-value">
              {profile.whatsapp_number || "Not provided"}
            </div>
          </div>

          <div className="profile-row">
            <div className="profile-label">
              <FiMapPin style={{ marginRight: "0.5rem" }} />
              Address
            </div>
            <div className="profile-value">
              {profile.communication_address || "Not provided"}
            </div>
          </div>

          <div className="profile-row">
            <div className="profile-label">
              <FiCreditCard style={{ marginRight: "0.5rem" }} />
              Wallet Address
            </div>
            <div className="profile-value" style={{ wordBreak: "break-all" }}>
              {profile.wallet_address || "Not provided"}
            </div>
          </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "1.5rem",
            padding: "1rem",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          <p style={{ color: "#666", fontSize: "0.875rem" }}>
            <strong>Note:</strong> To update your profile information, please
            contact an administrator.
          </p>
        </div>
      </div>
    </LifeSaverLayout>
  );
};

export default MyProfile;
